$(document).ready(function(){
    // Get the position of the element
    var elementPosition = $('.post-icon-container').offset().top;
    var lastElementPosition = $('.gh-container').offset().top;
    var elementHeight = $('.post-icon-container')[0].offsetHeight;
    var elementWidth = $('.post-icon-container')[0].offsetWidth;
    var containerHeight = $('.gh-content-2')[0].offsetHeight;
    var pLeft = $('.gh-content-2').find('p')[0].offsetLeft;
    // Listen for the scroll event
    $(window).scroll(function(){
        // Get the current scroll position
        var scrollPosition = $(this).scrollTop();
        // console.log(scrollPosition)
        
        if($(window).width() > 854) {
            // Compare the scroll position with the element position
            if (scrollPosition >= (lastElementPosition-120-elementHeight)){
                $('.post-icon-container').css({
                    'position': 'absolute',
                    // 'top': `${containerHeight-elementHeight}px`,
                    'top': `${containerHeight-elementHeight}px`,
                    'left': `-${60}px`
                });
            } else if (scrollPosition >= elementPosition) {
                // Set the element's position to fixed
                $('.post-icon-container').css({
                    'position': 'fixed',
                    'top': '0',
                    // 'left': `${195-pLeft}px`
                    'left': `${pLeft-elementWidth-5}px`
                });
            } else {
                // Reset the element's position
                $('.post-icon-container').css({
                    'position': 'absolute',
                    'top': '26px',
                    'left': `-${60}px`
                });
            }
        } else {
            if (scrollPosition >= (lastElementPosition-120-elementHeight)){
                $('.gh-content-2').css({
                    'padding-top': `0px`
                });
                $('.post-icon-container').css({
                    'position': 'relative',
                    'display': 'flex',
                    // 'left': `${0}px`,
                    'background-color': 'var(--background-color)',
                    // 'border-radius': '0',
                    // 'border': '0',
                    'padding-left': `0px`,
                    'width': 'auto',
                });
            } else if (scrollPosition >= elementPosition) {
                $('.gh-content-2').css({
                    'padding-top': `${elementHeight}px`
                });
                // Set the element's position to fixed
                $('.post-icon-container').css({
                    'position': 'fixed',
                    // 'top': '5px',
                    // 'left': `${30}px`
                    // 'left': `${pLeft}px`,
                    'padding-left': `${pLeft}px`,
                    'width': '100vw',
                    'background-color': 'var(--background-color)',
                    // 'border-radius': '5px',
                    // 'border': '1px solid black',
                });
            } else {
                $('.gh-content-2').css({
                    'padding-top': `0px`
                });
                // Reset the element's position
                $('.post-icon-container').css({
                    'position': 'relative',
                    'display': 'flex',
                    // 'left': `${0}px`,
                    'background-color': 'var(--background-color)',
                    // 'border-radius': '0',
                    // 'border': '0',
                    'padding-left': `0px`,
                    'width': 'auto',
                });
            }
        }
    });
    
    const copyPageURL = () => {
        // Get the current page URL
        var pageURL = window.location.href;
    
        // Create a temporary input element
        var tempInput = document.createElement("input");
        tempInput.value = pageURL;
        document.body.appendChild(tempInput);
    
        // Select the input field
        tempInput.select();
        tempInput.setSelectionRange(0, 99999); /* For mobile devices */
    
        // Copy the URL to the clipboard
        document.execCommand("copy");
    
        // Remove the temporary input element
        document.body.removeChild(tempInput);
    
        // Optionally, provide feedback to the user
        // alert("Page URL copied to clipboard: " + pageURL);
    }
    $('.copy-link-button').click(() => {
        copyPageURL();
        // $('.copy-link-text').css({
        //     'display': 'block',
        // });
        $('.copy-link-text').addClass('visible');
        setTimeout(() => {
            // $('.copy-link-text').css({
            //     'display': 'none',
            // });
        $('.copy-link-text').removeClass('visible');
    }, 1500);
    });
});